import { useNavigate } from '@/router/navigation'

interface ErrorPageProps {
  code: string
  title: string
  message: string
  showHome?: boolean
  showRefresh?: boolean
}

export function ErrorPage({
  code,
  title,
  message,
  showHome = true,
  showRefresh = false,
}: ErrorPageProps) {
  const navigate = useNavigate()

  const handleRefresh = () => {
    window.location.reload()
  }

  const handleGoHome = () => {
    navigate('/application')
  }

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="mb-6">
          <span className="text-8xl font-bold text-primary">{code}</span>
        </div>

        <svg className="w-24 h-24 text-gray-400 mx-auto mb-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>

        <h1 className="text-2xl font-semibold text-secondary mb-3">{title}</h1>
        <p className="text-gray-500 mb-8">{message}</p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          {showHome && (
            <button
              onClick={handleGoHome}
              className="px-6 py-3 bg-primary text-white rounded-lg font-medium hover:bg-primary-dark transition-colors"
            >
              Start Over
            </button>
          )}
          {showRefresh && (
            <button
              onClick={handleRefresh}
              className="px-6 py-3 bg-gray-100 text-secondary rounded-lg font-medium hover:bg-gray-200 transition-colors"
            >
              Refresh Page
            </button>
          )}
        </div>
      </div>
    </div>
  )
}
